import styled from 'styled-components';

export const Wrapper = styled.div`
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  display: flex;
`;
